import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import './Map.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import Header from '../../components/header/Header';
import Navbar from '../../components/navbar/Navbar';
import Footer from '../../components/Footer';

mapboxgl.accessToken = 'pk.eyJ1IjoidmlzaHdhbmF0aHZpc2h3YSIsImEiOiJja3B2MWc5MXowaGd4MnFwYTM4ODVrOGs5In0.BUkokW_i5ndS9bZWNQ17IA';

const MapScreen = () => {

    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng, setLng] = useState(77.580643);
    const [lat, setLat] = useState(12.972442);
    const [zoom, setZoom] = useState(9);

    useEffect(() => {
        if (map.current) return; // initialize map only once
        map.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: 'mapbox://styles/mapbox/streets-v12',
            center: [lng, lat],
            zoom: zoom
        });
    });

    useEffect(() => {
        if (!map.current) return; // wait for map to initialize
        map.current.on('move', () => {
            setLng(map.current.getCenter().lng.toFixed(4));
            setLat(map.current.getCenter().lat.toFixed(4));
            setZoom(map.current.getZoom().toFixed(2));
        });
    });

    return (
        <>
            <Header />
            <Navbar />
            <div className='container max-w-screen-xl mx-auto px-4 md:px-2 mb-16'>
                <div className='mt-20 text-center uppercase mb-4 text-xl font-bold sen-font'>map</div>
                <div className="sidebar">
                    Longitude: {lng} | Latitude: {lat} | Zoom: {zoom}
                </div>
                <div ref={mapContainer} className="map-container" />
            </div>
            <Footer />
        </>
        
    )
}

export default MapScreen